import { useAppSelector, useAppDispatch } from './app/hooks';
import { useParams, useSearchParams } from 'react-router-dom';

import { useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import AppLeftDrawer from './AppLeftDrawer';
import NotLoggedDesktopApp from './NotLoggedDesktopApp';
import App from './App';
import AppSpinner from './features/app-spinner/AppSpinner';
import dayjs, { Dayjs } from 'dayjs';
import {
	selectLastSessionChecked,
	selectIsAuthChecked,
	selectIsAuthenticated,
} from './features/auth/session/sessionSlice';
import { useAuthAuthorizedQuery, useInitQuery } from './api/index';

export default function AppInit() {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));
	const now = dayjs().valueOf();
	const dispatch = useAppDispatch();
	//let params = useParams();
	let [urlSearchParams] = useSearchParams();
	//console.log('params', params);
	//console.log('searchParams', urlSearchParams);

	let authState = urlSearchParams.get("state");
	let authCode = urlSearchParams.get("code");
	if (!authState || !authCode) {
		authState = "";
		authCode = "";
	}
	const {
		data: user,
		isLoading,
		isFetching,
		isSuccess,
		isError,
		error
	} = useInitQuery()
	let authChecked = useAppSelector(selectIsAuthChecked(now));
	let authIsChecked =  useAppSelector(selectIsAuthChecked(now));
	let nowd = new Date();
	const session = useSelector(selectIsAuthenticated(nowd));
	if (isLoading || isFetching) {
		return (<AppSpinner />);
	}
	//*
	//if (false) { this condition should check store:settings/drawer true false
	if (authIsChecked) {
		if (session) {
			if (!isMobile) {
				return ( <AppLeftDrawer /> );
			} else {
				return ( <App /> );
			}
		} else {
			if (!isMobile) {
				return ( <NotLoggedDesktopApp /> );
			} else {
				return ( <App /> );
			}

		}
	} else {
		if (session) {
			if (!isMobile) {
				return ( <AppLeftDrawer /> );
			} else {
				return (<App />);
			}
		} else {
			if (!isMobile) {
				return ( <AppLeftDrawer /> );
			} else {
				return (<App />);
			}

		}
	}
}
